const Walking = () => (
  <svg focusable={false} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48'>
    <g fill='none' fillRule='evenodd'>
      <circle cx={24} cy={24} r={20} fill='#FFE36E' />
      <g fill='#FFF' fillRule='nonzero' transform='translate(18 12)'>
        <path d='M4.102 14.203c-.104.814-.26 1.845-.441 2.204-.596 1.078-2.515 4.768-2.54 4.816-.286.55-.053 1.221.544 1.485.181.072.337.12.518.12.44 0 .882-.24 1.089-.623.026-.024 1.944-3.714 2.54-4.792.234-.431.409-.883.642-1.528.127-.414.22-1.12.074-1.332-.642-.94-2.331-1.521-2.75-1.799-.32-.213.31 1.044.324 1.449z' />
        <path d='M13.565 11.064c-.752-.55-1.919-1.533-2.23-1.964-.078-.12-.182-.336-.285-.551-.519-1.055-1.504-2.995-3.682-2.995 0 0-1.166-.024-1.53-.024-2.462-.048-4.07 1.964-4.459 2.683-.363.719-1.192 2.995-1.348 3.498-.13.455.156.934.648 1.054.078.024.156.024.26.024.414 0 .777-.24.907-.623.156-.479.96-2.66 1.244-3.21.078-.168.363-.551.778-.91-.415 1.605-.259 3.809-.181 4.743.052.6 1.192 1.222 1.84 1.63 1.063.67 2.697 2.204 3.034 2.898.26.551 1.374 3.474 1.944 4.792.182.431.648.719 1.115.719.156 0 .285-.024.44-.072.623-.216.934-.863.675-1.438-.078-.167-1.633-4.168-1.97-4.887-.286-.623-1.556-2.06-2.36-2.851 0 0 0-3.163.493-5.127.155.263.311.55.467.838.155.288.259.527.414.743.57.839 2.308 2.156 2.645 2.396.181.12.389.192.57.192.285 0 .545-.12.726-.312.311-.407.26-.934-.155-1.246z' />
        <ellipse
          cx='6.881'
          cy='2.5'
          rx='2.333'
          ry='2.3'
          transform='rotate(-89.039 6.881 2.5)'
        />
      </g>
    </g>
  </svg>
);

export default Walking;
